/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CitiesResponseDto,
  CountriesResponseDto,
  ErrorResponse,
  StatesResponseDto,
} from '../models/index';
import {
    CitiesResponseDtoFromJSON,
    CitiesResponseDtoToJSON,
    CountriesResponseDtoFromJSON,
    CountriesResponseDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    StatesResponseDtoFromJSON,
    StatesResponseDtoToJSON,
} from '../models/index';

export interface GetCitiesByStateRequest {
    countryCode: string;
    stateCode: string;
}

export interface GetStatesByCountryRequest {
    countryCode: string;
}

/**
 * 
 */
export class GeographyApi extends runtime.BaseAPI {

    /**
     * Get list of cities by country code and state code
     * Get cities by country code and state code
     */
    async getCitiesByStateRaw(requestParameters: GetCitiesByStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CitiesResponseDto>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getCitiesByState().'
            );
        }

        if (requestParameters['stateCode'] == null) {
            throw new runtime.RequiredError(
                'stateCode',
                'Required parameter "stateCode" was null or undefined when calling getCitiesByState().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/geography/countries/{countryCode}/states/{stateCode}/cities`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters['countryCode']))).replace(`{${"stateCode"}}`, encodeURIComponent(String(requestParameters['stateCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CitiesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get list of cities by country code and state code
     * Get cities by country code and state code
     */
    async getCitiesByState(requestParameters: GetCitiesByStateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CitiesResponseDto> {
        const response = await this.getCitiesByStateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of all countries
     * Get all countries
     */
    async getCountriesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CountriesResponseDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/geography/countries`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountriesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get list of all countries
     * Get all countries
     */
    async getCountries(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CountriesResponseDto> {
        const response = await this.getCountriesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get list of states by country code
     * Get states by country code
     */
    async getStatesByCountryRaw(requestParameters: GetStatesByCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatesResponseDto>> {
        if (requestParameters['countryCode'] == null) {
            throw new runtime.RequiredError(
                'countryCode',
                'Required parameter "countryCode" was null or undefined when calling getStatesByCountry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/geography/countries/{countryCode}/states`.replace(`{${"countryCode"}}`, encodeURIComponent(String(requestParameters['countryCode']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatesResponseDtoFromJSON(jsonValue));
    }

    /**
     * Get list of states by country code
     * Get states by country code
     */
    async getStatesByCountry(requestParameters: GetStatesByCountryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatesResponseDto> {
        const response = await this.getStatesByCountryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
